import { FC } from 'react';
import { FileText, Trash } from 'lucide-react';
import { Button } from '@new/common/ui/Button/Button';

interface FilePreviewCardProps {
  fileName: string;
  fileSize: string;
  onView: () => void;
  onRemove: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  submitDisabled?: boolean;
}

export const FilePreviewCard: FC<FilePreviewCardProps> = ({
  fileName,
  fileSize,
  onView,
  onRemove,
  onSubmit,
  isSubmitting,
  submitDisabled = false,
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-xl border-2 border-(--neutral-black-NB100) p-4 shadow-xs">
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <div className="flex items-center gap-3 cursor-pointer" onClick={onView}>
          <FileText className="text-(--primary-O900) shrink-0 w-5 lg:w-6 h-5 lg:h-6" />
          <div className="flex flex-col">
            <span className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB1000)! font-medium wrap-break-word">
              {fileName}
            </span>
            <span className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB600)!">
              {fileSize}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
        <Button onClick={onRemove} variant="ghost" aria-label="Remove file">
          <Trash size={16} className="text-(--neutral-black-NB600)" />
        </Button>
        <Button onClick={onSubmit} disabled={submitDisabled || isSubmitting} className="flex-1">
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </Button>
      </div>
    </div>
  );
};
